if (!customElements.get('adev-featured-collection')) {
    customElements.define('adev-featured-collection', class adevFeaturedCollection extends HTMLElement {
        constructor() {
            super();

            this.carouselEl = this.querySelector('[data-adev-featured-collection="items"]');
            this.carouselPrevButton = this.querySelector('[data-adev-featured-collection="carousel-prev"]');
            this.carouselNextButton = this.querySelector('[data-adev-featured-collection="carousel-next"]');
        }
        
        getlCellAlign() {
            return window.innerWidth < 992 ? 'center' : 'left';
        }

        getInitialIndex () {
            return window.innerWidth < 992 ? 1 : 0;
        }
        
        initCarousel(){
            if (!this.carouselEl) return;

            let settings = {
                cellAlign: this.getlCellAlign(),
                contain: false,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: false,
                initialIndex: this.getInitialIndex(),
                adaptiveHeight: false,
                on: {
                    ready: () => {
                        this.carouselEl.classList.add('adev--flickity-ready');
                    },
                    settle: () => {
                        this.carouselEl.classList.add('adev--flickity-ready');
                        this.carouselEl.classList.remove('adev--flickity-moving');
                    },
                    dragStart: () => {
                        this.carouselEl.classList.add('adev--flickity-moving');
                    },
                    dragEnd: () => {
                        this.carouselEl.classList.remove('adev--flickity-moving');
                    },
                    change: () => {
                        this.updateDotsBar();
                    },
                    select: () => {
                        
                    }
                }
            };

            this.carouselInstance = new Flickity(this.carouselEl, settings);

            this.initArrows();
            this.initDotsBar();
        }

        goPrev(){
            if(this.carouselInstance){
                this.carouselInstance.previous();
            }
        }

        goNext(){
            if(this.carouselInstance){
                this.carouselInstance.next();
            }
        }

        initArrows() {
            if (this.carouselPrevButton) {
                this.carouselPrevButton.addEventListener('click', this.goPrev.bind(this));
            }

            if (this.carouselNextButton) {
                this.carouselNextButton.addEventListener('click', this.goNext.bind(this));
            }
        }

        destroyArrows() {
            if (this.carouselPrevButton) {
                this.carouselPrevButton.removeEventListener('click', this.goPrev.bind(this));
            }

            if (this.carouselNextButton) {
                this.carouselNextButton.removeEventListener('click', this.goNext.bind(this));
            }
        }

        initDotsBar() {
            if (!this.carouselInstance) return;

            const dotsBar = this.querySelector('[data-adev-featured-collection="progress-dots"]');
            
            if (!dotsBar) return;

            this.updateDotsBar();

            this.querySelectorAll(`[data-adev-featured-collection="progress-dot"]`).forEach(dot => {
                dot.addEventListener('click', this.onDotClick.bind(this));
            });

            window.matchMedia('(max-width: 991px)').addEventListener('change', this.updateDotsBar.bind(this));
        }

        onDotClick(e) {
            const index = parseInt(e.currentTarget.getAttribute('data-index'), 10);
            if (isNaN(index) || !this.carouselInstance) return;

            this.carouselInstance.select(index);
        }

        updateDotsBar() {
            if (!this.carouselInstance) return;

            const selectedIndex = this.carouselInstance.selectedIndex;
            
            const dot = this.querySelector(`[data-index="${selectedIndex}"][data-adev-featured-collection="progress-dot"]`);
            if (!dot) return;

            const activeDot = this.querySelector(`[data-adev-featured-collection="progress-dot"].is--active`);

            if(activeDot) activeDot.classList.remove('is--active');

            dot.classList.add('is--active');
        }

        destroyDotsBar() {
            this.querySelectorAll(`[data-adev-featured-collection="progress-dot"]`).forEach(dot => {
                dot.removeEventListener('click', this.onDotClick.bind(this));
            });

            window.matchMedia('(max-width: 991px)').removeEventListener('change', this.updateDotsBar.bind(this));
        }

        destroyCarousel(){
            if(this.carouselInstance){
                this.carouselInstance.destroy();
            }

            this.destroyArrows();
            this.destroyDotsBar();
        }

        connectedCallback() {
            this.initCarousel();
        }

        disconnectedCallback() {
            this.destroyCarousel();
        }
    });
}